import MarketExecutiveSpiderDashboardController from 'lumen/controllers/market/executive/spider-dashboard';

export default class MarketHeatmapController extends MarketExecutiveSpiderDashboardController {}
